import { ItemType } from '@/shared/api-generated-types'
import { createContext, useContext } from 'react'

export const BookmarksTabContext = createContext<ItemType>(ItemType.Class)
export const useBookmarksTab = (): ItemType => useContext(BookmarksTabContext)
